import { z } from 'zod'

import { EMAIL_CONSTRAINTS } from './regex'

/**
 * Email валидация - Zod схемы
 */

/**
 * Zod схема для обязательного email
 * Включает trim, toLowerCase, проверку формата и длины
 */
export const emailSchema = z
	.string({ required_error: 'Укажите email' })
	.trim()
	.toLowerCase()
	.email({ message: 'Некорректно введен email' })
	.min(EMAIL_CONSTRAINTS.MIN_LENGTH, { message: `Необходимо минимум ${EMAIL_CONSTRAINTS.MIN_LENGTH} символов` })
	.max(EMAIL_CONSTRAINTS.MAX_LENGTH, { message: `Максимум ${EMAIL_CONSTRAINTS.MAX_LENGTH} символа` })

/**
 * Zod схема для опционального email
 * Если поле пустое, преобразуется в null
 */
export const emailSchemaOptional = z
	.string()
	.trim()
	.toLowerCase()
	.optional()
	.transform(value => (value === '' ? null : value))
	.nullable()
	.refine(value => value == null || (typeof value === 'string' && z.string().email().safeParse(value).success), {
		message: 'Некорректно введен email'
	})
	.refine(value => value == null || (typeof value === 'string' && value.length >= EMAIL_CONSTRAINTS.MIN_LENGTH), {
		message: `Необходимо минимум ${EMAIL_CONSTRAINTS.MIN_LENGTH} символов`
	})
	.refine(value => value == null || (typeof value === 'string' && value.length <= EMAIL_CONSTRAINTS.MAX_LENGTH), {
		message: `Максимум ${EMAIL_CONSTRAINTS.MAX_LENGTH} символа`
	})
